export const audiencesUrl = '/admin/audience-campaigns/contacts'
